"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var Progress;
(function (Progress) {
    function calc(done, total) {
        if (!total) {
            return { done: 0, total: 0, percent: 0 };
        }
        const percent = done == 0 ? 0 : Math.round((done / total) * 100);
        return { done, total, percent };
    }
    Progress.calc = calc;
})(Progress || (exports.Progress = Progress = {}));
//# sourceMappingURL=Progress.js.map